import _ from 'lodash';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { clearConnectElements, connectElements } from './connect-elements';

const setStickyPanel = (editor) => {
  // StickyPanel のカスタマイズ
  const headMenuElement = document.querySelector('.pmm-head-menu');
  const headMenuElementComputedStyle = window.getComputedStyle(headMenuElement);
  const headMenuElementHeight =
    Number(headMenuElement.offsetHeight) +
    Number(headMenuElementComputedStyle.marginTop.replace(/px$/, '')) +
    Number(headMenuElementComputedStyle.marginBottom.replace(/px$/, ''));
  const originalCheckIfShouldBeSticky = editor.ui.view.stickyPanel._checkIfShouldBeSticky;
  const zIndex = 8999;
  const contentsElement = document.querySelector('#contents');
  contentsElement.addEventListener('scroll', () => {
    editor.ui.view.stickyPanel._checkIfShouldBeSticky();
  });
  window.addEventListener('resize', () => {
    setTimeout(() => {
      // タイムラグが必要
      editor.ui.view.stickyPanel._checkIfShouldBeSticky();
    }, 100);
  });
  headMenuElement.classList.add('ck-reset_all-excluded'); // 元々のスタイルを保持するために必要
  editor.ui.view.stickyPanel._checkIfShouldBeSticky = () => {
    const toolbarElement = document.querySelector('.ck-toolbar');
    const contentElement = document.querySelector('.ck-editor__main');
    if (!toolbarElement || !contentElement) return;
    const contentElementWidth = contentElement.offsetWidth + 'px';
    const ckeditorElement = document.getElementById('ckeditor');
    const ckeditorRect = ckeditorElement.getBoundingClientRect();
    const ckeditorWidth = ckeditorElement.offsetWidth + 'px';
    originalCheckIfShouldBeSticky.call(editor.ui.view.stickyPanel);
    editor.ui.view.stickyPanel.isActive = true; // フォーカスが外れても sticky にする
    const isSticky = editor.ui.view.stickyPanel.isSticky;
    if (isSticky === true) {
      const scrollX = contentsElement ? contentsElement.scrollLeft : 0;
      const editorElement = document.querySelector('.ck-editor');
      editorElement.style.minWidth = contentElement.offsetWidth + 'px';
      Object.assign(headMenuElement.style, {
        // ヘッダーメニューのスタイル
        position: 'fixed',
        top: '0px',
        left: ckeditorRect.left - scrollX + 'px',
        padding: '5px 10px',
        zIndex: zIndex,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        width: ckeditorWidth,
      });
      Object.assign(toolbarElement.style, {
        // ツールバーのスタイル
        position: 'fixed',
        top: headMenuElement.offsetHeight - 1 + 'px',
        left: ckeditorRect.left - scrollX + 'px',
        zIndex: zIndex,
        width: contentElementWidth,
      });
      Object.assign(ckeditorElement.style, {
        // CKEditor のスタイル
        marginTop: headMenuElementHeight + 'px',
      });
    } else {
      Object.assign(headMenuElement.style, {
        // ヘッダーメニューのスタイル
        position: 'relative',
        top: '0px',
        left: '0px',
        padding: '0',
        zIndex: 100,
        backgroundColor: 'transparent',
        border: 'none',
        width: '100%',
      });
      Object.assign(toolbarElement.style, {
        // ツールバーのスタイル
        position: '',
        top: '0px',
        zIndex: 1,
        width: contentElementWidth,
      });
      Object.assign(ckeditorElement.style, {
        // CKEditor のスタイル
        marginTop: '0px',
      });
    }
  };
};

// MutationObserver でコンテンツを監視
const setMutationObserver = (editor) => {
  const el = document.querySelector('.ck-body-wrapper');
  if (el) {
    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        const nodes = mutation.addedNodes;
        for (const node of nodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const disabledBackgroundColor = '#f2f2f2';
            const disabledTextColor = '#676767';
            let disablingSelectors = {};
            if (node.classList.contains('ck-table-cell-properties-form')) {
              // セルのプロパティが開いたとき
              disablingSelectors = {
                borderStyleButton: '.ck-table-form__border-style button',
                borderColorInput: '.ck-table-form__border-color input',
                borderColorButton: '.ck-table-form__border-color button',
                borderWidthInput: '.ck-table-form__border-width input',
                heightInput: '.ck-table-form__dimensions-row__height input',
                paddingInput: '.ck-table-cell-properties-form__padding input',
                backgroundInput: '.ck-table-cell-properties-form__background input',
                backgroundButton: '.ck-table-cell-properties-form__background button',
              };
              setCellPropertiesFormLayer(editor);
            } else if (node.classList.contains('ck-table-properties-form')) {
              // テーブルのプロパティが開いたとき
              disablingSelectors = {
                borderColorInput: '.ck-table-form__border-color input',
                borderColorButton: '.ck-table-form__border-color button',
                borderWidthInput: '.ck-table-form__border-width input',
                widthtInput: '.ck-table-form__dimensions-row__width input',
                heightInput: '.ck-table-form__dimensions-row__height input',
                backgroundInput: '.ck-table-properties-form__background input',
                backgroundButton: '.ck-table-properties-form__background button',
                alignmentLeftButton: '.ck-table-properties-form__alignment-row button:nth-child(1)',
                alignmentCenterButton: '.ck-table-properties-form__alignment-row button:nth-child(2)',
                alignmentRightButton: '.ck-table-properties-form__alignment-row button:nth-child(3)',
              };
              setTablePropertiesFormLayer(editor);
            }
            for (let key in disablingSelectors) {
              const selector = disablingSelectors[key];
              const el = document.querySelector(selector);
              el.setAttribute('disabled', 'disabled');
              el.style.backgroundColor = disabledBackgroundColor;
              const parentEl = el.parentElement;
              parentEl.classList.add('ck-disabled');
              const tagName = el.tagName.toLowerCase();
              if (tagName !== 'input') {
                const children = el.children;
                for (let child of children) {
                  child.setAttribute('disabled', 'disabled');
                  child.style.setProperty('color', disabledTextColor, 'important');
                  child.style.backgroundColor = disabledBackgroundColor;
                }
              }
            }
          }
        }
      }
    };

    const config = {
      childList: true,
      attributes: true,
      subtree: true,
    };

    const observer = new MutationObserver(callback);
    observer.observe(el, config);
  }
};
const setCellPropertiesFormLayer = (editor) => {
  const form = document.querySelector('.ck-table-cell-properties-form');
  const existsLayer1 = document.getElementById('layer1');
  const language = editor.locale.language;
  // 共通のスタイル
  const layerWidth = form.offsetWidth - 10;
  const backgroundColor = '#555';
  const opacity = '0.45';
  const zIndex = '100';
  // layer1 のスタイル
  const layer1Top = 43;
  const layer1Left = 5;
  const layer1Height = 141;
  // Layer2 のスタイル
  const layer2Left = language === 'en' ? 99 : 87;
  const layer2Height = 68;
  if (!existsLayer1) {
    const layer1 = document.createElement('div');
    layer1.setAttribute('id', 'layer1');
    Object.assign(layer1.style, {
      position: 'absolute',
      top: `${layer1Top}px`,
      left: `${layer1Left}px`,
      width: `${layerWidth}px`,
      height: `${layer1Height}px`,
      backgroundColor: backgroundColor,
      opacity: opacity,
      zIndex: zIndex,
    });
    form.appendChild(layer1);
  }
  const existsLayer2 = document.getElementById('layer2');
  if (!existsLayer2) {
    const layer2 = document.createElement('div');
    layer2.setAttribute('id', 'layer2');
    Object.assign(layer2.style, {
      position: 'absolute',
      top: `${layer1Top + layer1Height}px`,
      left: `${layer2Left}px`,
      width: `${layerWidth - layer2Left + layer1Left}px`,
      height: `${layer2Height}px`,
      backgroundColor: backgroundColor,
      opacity: opacity,
      zIndex: zIndex,
    });
    form.appendChild(layer2);
  }
};
const setTablePropertiesFormLayer = () => {
  const form = document.querySelector('.ck-table-properties-form');
  const existsLayer1 = document.getElementById('layer1');
  // 共通のスタイル
  const layerWidth = form.offsetWidth - 5;
  const backgroundColor = '#555';
  const opacity = '0.45';
  const zIndex = '100';
  // layer1 のスタイル
  const layer1Top = 43;
  const layer1Left = 98;
  const layer1Height = 74;
  // Layer2 のスタイル
  const layer2Left = 5;
  const layer2Height = 140;
  if (!existsLayer1) {
    const layer1 = document.createElement('div');
    layer1.setAttribute('id', 'layer1');
    Object.assign(layer1.style, {
      position: 'absolute',
      top: `${layer1Top}px`,
      left: `${layer1Left}px`,
      width: `${layerWidth - layer1Left}px`,
      height: `${layer1Height}px`,
      backgroundColor: backgroundColor,
      opacity: opacity,
      zIndex: zIndex,
    });
    form.appendChild(layer1);
  }
  const existsLayer2 = document.getElementById('layer2');
  if (!existsLayer2) {
    const layer2 = document.createElement('div');
    layer2.setAttribute('id', 'layer2');
    Object.assign(layer2.style, {
      position: 'absolute',
      top: `${layer1Top + layer1Height}px`,
      left: `${layer2Left}px`,
      width: `${layerWidth - layer2Left}px`,
      height: `${layer2Height}px`,
      backgroundColor: backgroundColor,
      opacity: opacity,
      zIndex: zIndex,
    });
    form.appendChild(layer2);
  }
};
const setCkfinderRefresh = () => {
  window.addEventListener('storage', (e) => {
    const key = e.key;
    const newValue = e.newValue;
    const oldValue = e.oldValue;
    if (key === 'ckfinderRefresh' && newValue !== oldValue) {
      const currentEditor = window.editor; // ckeditor インスタンスを取得
      currentEditor.model.change((writer) => {
        const range = currentEditor.model.createRangeIn(currentEditor.model.document.getRoot());
        for (const value of range.getWalker({ ignoreElementEnd: true })) {
          if (value.item.is('element') && value.item.name === 'imageBlock') {
            const element = value.item;
            const url = element.getAttribute('src');
            if (url) {
              const baseUrl = window.location.origin;
              const fullUrl = url.startsWith('http') ? url : baseUrl + url;
              const parsedUrl = new URL(fullUrl);
              const params = parsedUrl.searchParams;
              const time = new Date().getTime();
              params.set('time', time);
              const newSrc = url.startsWith('http') ? parsedUrl.href : parsedUrl.href.replace(baseUrl, '');
              writer.setAttribute('src', newSrc, element);
            }
          }
        }
      });
    }
  });
};

const hasCkeditorListClass = (checkingClassNames) => {
  let hasListClass = false;
  const allClassNames = window.editor.customList.getAllClassNames();
  if (checkingClassNames instanceof Array) {
    for (let className of checkingClassNames) {
      if (allClassNames.includes(className)) {
        hasListClass = true;
        break;
      }
    }
  }
  return hasListClass;
};

const initCkeditorList = (editor) => {
  editor.editing.view.document.on('keydown', (e, data) => {
    if (data.domEvent.key === 'Enter') {
      // Enter キーが押されたとき
      const editor = window.editor;
      const model = editor.model;
      const selection = model.document.selection;
      const blocks = [...selection.getSelectedBlocks()];

      if (blocks.length > 0) {
        const block = blocks[0];
        const nodeAttributes = block.getAttribute('htmlPAttributes');

        if (nodeAttributes && nodeAttributes.classes && hasCkeditorListClass(nodeAttributes.classes)) {
          // リスト用のクラスが入っている場合
          let currentText = '';
          try {
            currentText = block.getChild(0).data;
          } catch (e) {}

          if (currentText.length === 0) {
            // テキストが空の場合はリストを終了する
            editor.model.change((writer) => {
              const newBlock = writer.createElement('paragraph');
              writer.insert(newBlock, block, 'after');
              writer.remove(block); // 現在のブロックは削除
              writer.setSelection(newBlock, 'in');
            });
            data.preventDefault();
          }
        }
      }
    }
  });
};

const initCkeditorCommentEvents = (editor) => {
  const makeLine = (threadId) => {
    const startElements = Array.from(document.querySelectorAll(`[data-comment="${threadId}"]`));
    const endElements = Array.from(document.querySelectorAll(`[data-thread-id="${threadId}"]`));
    if (startElements.length > 0 && endElements.length > 0) {
      clearConnectElements();
      connectElements(startElements, endElements, {
        // 斜めの線
        borderStyle: 'solid',
        borderWidth: 4,
        borderColor: '#FF0000',
        borderOpacity: 0.5,
        dotSize: 17,
        start: {
          basePosition: 'topRight',
          offset: { x: 25, y: 'center' },
          withDot: false,
        },
        end: {
          basePosition: 'topLeft',
          offset: { x: -13, y: 27 },
          withDot: true,
        },
      });
      connectElements(startElements, startElements, {
        // 縦の線
        borderStyle: 'solid',
        borderWidth: 10,
        borderColor: '#FF0000',
        borderOpacity: 0.5,
        borderLineCap: 'butt', // 角を丸くしない
        start: {
          basePosition: 'topRight',
          offset: { x: 25, y: -5 },
          withDot: false,
        },
        end: {
          basePosition: 'bottomRight',
          offset: { x: 25, y: 5 },
          withDot: false,
        },
      });
    }
  };
  // CommentsRepository
  const commentsRepository = editor.plugins.get('CommentsRepository');
  let scrollingThreadId = null;
  commentsRepository.on('addComment', (evt, comment) => {
    addAttachmentLinks();
    addReactionButtons();
  });
  // アクティブなスレッドが変更されたとき
  commentsRepository.on('change:activeCommentThread', (evt, propName, activeThread) => {
    requestAnimationFrame(() => {
      addAttachmentLinks();
      addReactionButtons();
      decorateComment();
      // リアクション
      if (activeThread) {
        const comments = activeThread.comments || [];
        Array.from(comments).forEach((comment) => {
          const commentId = comment.id;
          updateReactionInfo(commentId);
        });
      }
      clearConnectElements();
      if (activeThread && activeThread.id) {
        const threadId = activeThread.id;
        scrollingThreadId = threadId;
        let sameCount = 0;
        let lastTop = 0;
        let limitCount = 0;
        const timer = setInterval(() => {
          const target = document.querySelector(`.ck-thread[data-thread-id="${threadId}"]`);
          if (target) {
            const currentTop = target.getBoundingClientRect().top;
            if (currentTop === lastTop) {
              sameCount++;
            } else {
              sameCount = 0;
            }
            if (sameCount >= 5) {
              // このカウントが続くと、位置が変わらないと判断して処理を抜ける
              clearInterval(timer);
              requestAnimationFrame(() => {
                // 念のため、遅延を入れる
                decorateComment(scrollingThreadId);
                makeLine(scrollingThreadId);
                const textElement = document.querySelector(`.ck-comment-marker[data-comment="${scrollingThreadId}"]`);
                if (textElement) {
                  textElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              });
              return;
            }
            lastTop = currentTop;
          }
          limitCount++;
          if (limitCount > 50) {
            // 念のための保険で処理を抜ける
            clearInterval(timer);
            return;
          }
        }, 100);
      }
    });
  });
  document.addEventListener('click', (e) => {
    // 表示中の全てリアクションコントローラーを非表示にする
    hideAllReactionControllers();
  });
  updateAllReactionInfo();
};
const decorateComment = (threadId) => {
  let loop = 0;
  const timer = setTimeout(() => {
    const textElements = document.querySelectorAll(`.ck-comment-marker[data-comment="${threadId}"]`);
    if (textElements.length > 0) {
      clearTimeout(timer);
      textElements.forEach((textElement) => {
        textElement.setAttribute('is-search-selected', 'true');
      });
    }
    loop++;
    if (loop > 10) {
      clearTimeout(timer);
    }
  }, 100);
};
const duplicateCommentThread = (threadId, removeOriginalCommentThread = false) => {
  const editor = window.editor;
  const commentTypeId = threadId.toString().split('-')[0];
  if (commentTypeId) {
    const commentsRepository = editor.plugins.get('CommentsRepository');
    const commentThread = commentsRepository.getCommentThread(threadId);
    const newThreadId = editor.utils.getNewThreadId(commentTypeId);
    editor.execute('addCommentThread', { threadId: newThreadId });
    const newCommentThread = commentsRepository.getCommentThread(newThreadId);
    const user = editor.config._config.customValues.user;
    commentThread.comments.map((comment) => {
      const newCommentId = editor.utils.uid();
      const reactionItems = window.reactionItems || [];
      /* コメント本体の複製 */
      newCommentThread.addComment({
        commentId: newCommentId,
        authorId: comment.author.id,
        content: comment.content,
        createdAt: new Date(comment.createdAt),
      });
      /* 分離してwindowオブジェクトに格納されているデータの複製 */
      // リアクションを複製
      if (reactionItems.length > 0) {
        const newReactionItems = reactionItems
          .filter((item) => item.commentId === comment.id)
          .map((item) => ({
            uuid: item.uuid,
            commentId: newCommentId,
            type: item.type,
            user: user,
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
          }));
        window.reactionItems = [...window.reactionItems, ...newReactionItems];
      }
      // TODO: 添付ファイルを複製
    });
    if (removeOriginalCommentThread) {
      commentThread.remove();
    }
  }
};

// コメントの添付ファイル
let clearAttachmentCommentIds = [];
class CommentAttachment {
  // データ構造クラス
  constructor() {
    this.comment = null;
    this.downloadItems = [];
  }
  /*
    @param {Comment} comment CKEditorプラグインから取得できるインスタンス
    const commentsRepository = editor.plugins.get('CommentsRepository');
    const commentThread = commentsRepository.getCommentThread(threadId);
    const comment = commentThread.getComment(commentId); // <-- これ
  */
  setComment(comment) {
    this.comment = comment;
  }
  addDownloadItem(url, fileName) {
    const uuid = uuidv4();
    this.downloadItems.push({ url, fileName, uuid });
  }
}
const toggleAttachmentDeleteLink = (e, show) => {
  const deleteLink = e.target.querySelector('.ck-comment__file-delete-link');
  if (deleteLink) {
    deleteLink.style.display = show ? 'block' : 'none';
  }
};
const onAttachmentDeleteClick = (e) => {
  e.preventDefault();
  const message = window.editor.i18n.t('この添付ファイルを削除しますか?\n\n【注意】削除は保存するまで反映されません。');
  if (confirm(message)) {
    const target = e.target;
    const commendId = target.getAttribute('data-comment-id');
    const uuid = target.getAttribute('data-uuid');
    const itemElement = target.closest(`.ck-comment__file-download-link-item[data-uuid="${uuid}"]`);
    if (commendId && itemElement) {
      // DOM 削除
      itemElement.remove();
      // グローバル変数も削除
      window.commentAttachments = window.commentAttachments.filter((commentAttachment) => {
        commentAttachment.downloadItems = commentAttachment.downloadItems.filter((item) => {
          return item.uuid !== uuid;
        });

        return commentAttachment;
      });
    }
  }
};
const getAttachmentItem = (comment, url, fileName, uuid) => {
  const itemElement = document.createElement('div');
  itemElement.className = 'ck-comment__file-download-link-item';
  itemElement.setAttribute('data-comment-id', comment.id);
  itemElement.setAttribute('data-uuid', uuid);
  itemElement.addEventListener('mouseenter', (e) => toggleAttachmentDeleteLink(e, true));
  itemElement.addEventListener('mouseleave', (e) => toggleAttachmentDeleteLink(e, false));
  // ダウンロードリンク
  const downloadLinkElement = document.createElement('a');
  downloadLinkElement.href = url;
  downloadLinkElement.innerText = fileName;
  downloadLinkElement.className = 'ck-comment__file-download-link';
  downloadLinkElement.setAttribute('data-url', url);
  downloadLinkElement.setAttribute('data-comment-id', comment.id);
  downloadLinkElement.setAttribute('data-uuid', uuid);
  itemElement.appendChild(downloadLinkElement);
  // 削除リンク
  const deleteLinkElement = document.createElement('a');
  deleteLinkElement.href = '#';
  deleteLinkElement.innerHTML = ''; // 画面がチラつくのでafter疑似要素 + absoluteで表示する
  deleteLinkElement.style.display = 'none'; // 初期状態で非表示
  deleteLinkElement.className = 'ck-comment__file-delete-link';
  deleteLinkElement.setAttribute('data-comment-id', comment.id);
  deleteLinkElement.setAttribute('data-uuid', uuid);
  deleteLinkElement.addEventListener('click', onAttachmentDeleteClick);
  itemElement.appendChild(deleteLinkElement);

  return itemElement;
};
const addAttachmentLink = (commentAttachment) => {
  const comment = commentAttachment.comment;
  const downloadItems = commentAttachment.downloadItems;
  // グローバル変数に追加
  const commentAttachments = window.commentAttachments || [];
  const targetIndex = commentAttachments.findIndex((attachment) => {
    return attachment.comment.id === comment.id;
  });
  if (targetIndex !== -1) {
    // 既存データに追加
    downloadItems.forEach((item) => {
      const url = item.url;
      const fileName = item.fileName;
      const uuid = item.uuid;
      commentAttachments[targetIndex].downloadItems.push({ url, fileName, uuid });
    });
    window.commentAttachments = commentAttachments;
  } else {
    window.commentAttachments.push(commentAttachment);
  }
  // 描画済みフラグを解除して再描画
  clearAttachmentCommentIds.push(comment.id);
  addAttachmentLinks();
};
const addAttachmentLinks = (refreshingCommentIds = []) => {
  const editor = getEditor();
  if (!editor) return;
  // リフレッシュ対象のコメントIDをクリア
  clearAttachmentCommentIds.forEach((commentId) => {
    const commentElement = document.querySelector(`.ck-comment[data-comment-id="${commentId}"]`);
    if (commentElement) {
      commentElement.removeAttribute('data-has-attachment');
      // DOM&クリアID削除
      const wrapperElement = commentElement.querySelector('.ck-comment__file-download-link-wrapper');
      wrapperElement.innerHTML = '';
      clearAttachmentCommentIds = clearAttachmentCommentIds.filter((id) => id !== commentId);
    }
  });
  // まだ添付リンクが追加されていない要素を取得
  const commentElements = document.querySelectorAll('.ck-comment:not([data-has-attachment][data-comment-id])');
  [].forEach.call(commentElements, (commentElement) => {
    const commentId = commentElement.getAttribute('data-comment-id');
    const targetElement = commentElement.querySelector('.ck-annotation__content-wrapper');
    if (targetElement) {
      const wrapperClassName = 'ck-comment__file-download-link-wrapper';
      let wrapperElement = targetElement.querySelector(`.${wrapperClassName}`);
      if (!wrapperElement) {
        wrapperElement = document.createElement('div');
        wrapperElement.className = wrapperClassName;
      }
      wrapperElement.setAttribute('data-comment-id', commentId);
      const commentAttachments = window.commentAttachments || [];
      const commentAttachment = commentAttachments.find((item) => {
        return item.comment.id === commentId;
      });
      if (commentAttachment) {
        const comment = commentAttachment.comment;
        const downloadItems = commentAttachment.downloadItems || [];
        for (const item of downloadItems) {
          const url = item.url;
          const fileName = item.fileName;
          const uuid = item.uuid;
          const itemElement = getAttachmentItem(comment, url, fileName, uuid);
          wrapperElement.appendChild(itemElement);
        }
      }
      // ck-reaction-containerがある場合、その直前に挿入。ないなら最後に挿入
      const reactionContainerElement = targetElement.querySelector('.ck-reaction-container');
      if (reactionContainerElement) {
        targetElement.insertBefore(wrapperElement, reactionContainerElement);
      } else {
        targetElement.appendChild(wrapperElement);
      }
    }
    commentElement.setAttribute('data-has-attachment', 'true');
  });
};

// コメントのリアクション
const reactionTypes = [
  { type: 'accept', icon: '◎' },
  { type: 'reject', icon: '❎' },
  { type: 'view', icon: '👀' },
];
const addReactionButtons = () => {
  const svgIcon = `<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16" fill="currentColor" style="vertical-align: text-bottom;">
    <circle cx="8" cy="8" r="7.5" stroke="none" fill="currentColor" fill-opacity="0.1"/>
    <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1" fill="none"/>
    <circle cx="5.5" cy="6.7" r="1" fill="currentColor"/>
    <circle cx="10.5" cy="6.7" r="1" fill="currentColor"/>
    <path d="M5 10.5 Q8 12.5 11 10.5" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round"/>
  </svg>`;
  const editor = getEditor();
  if (!editor) return;
  const isReadOnly = _.get(editor, 'config._config.comments.editorConfig.disabled', true);
  // まだリアクション・ボタンが追加されていない要素を取得
  const commentElements = document.querySelectorAll('.ck-comment:not([data-has-reaction][data-comment-id])');
  [].forEach.call(commentElements, (commentElement) => {
    const commentId = commentElement.getAttribute('data-comment-id');
    const targetElement = commentElement.querySelector('.ck-annotation__content-wrapper');
    if (targetElement) {
      // メインのコンテナ
      const containerElement = document.createElement('div');
      containerElement.className = 'ck-reaction-container';
      // アイコンブロック
      const iconContainerElement = document.createElement('div');
      iconContainerElement.className = 'ck-reaction-icon-container';
      const reactionIconElement = document.createElement('button');
      reactionIconElement.className = 'ck-reaction-button';
      reactionIconElement.innerHTML = svgIcon;
      reactionIconElement.setAttribute('data-comment-id', commentId);
      if (isReadOnly) {
        reactionIconElement.setAttribute('disabled', 'disabled');
        reactionIconElement.style.opacity = '0.3';
      }
      reactionIconElement.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideAllReactionControllers();
        // 非表示のコントローラーブロックを表示する
        const controllerContainerElement = commentElement.querySelector(
          '.ck-reaction-controller-container[data-comment-id="' + commentId + '"]'
        );
        // このユーザーがリアクションしたかどうか
        const userId = getLoginUserId();

        reactionTypes.forEach((reactionType) => {
          const isReacted = window.reactionItems.some(
            (item) => item.commentId === commentId && item.user.user_id === userId && item.type === reactionType.type
          );
          const type = reactionType.type;
          const selector = `.ck-reaction-controller-button[data-comment-id="${commentId}"][data-reaction-type="${type}"]`;
          const buttonElement = controllerContainerElement.querySelector(selector);
          buttonElement.setAttribute('data-is-reacted', isReacted.toString());
        });

        // 背景色の取得
        const commentThreadElement = commentElement.closest('.ck-thread');
        const threadId = commentThreadElement ? commentThreadElement.getAttribute('data-thread-id') : null;
        const commentTextElement = document.querySelector('.ck-comment-marker[data-comment="' + threadId + '"]');
        let backgroundColor = '#fff'; // デフォルトの背景色
        if (commentTextElement) {
          // コメントの背景色を取得
          backgroundColor = window.getComputedStyle(commentTextElement).backgroundColor;
          // 少しだけ明るくする
          const rgb = backgroundColor.match(/\d+/g);
          if (rgb) {
            const r = Math.min(255, Number(rgb[0]) + 30);
            const g = Math.min(255, Number(rgb[1]) + 30);
            const b = Math.min(255, Number(rgb[2]) + 30);
            backgroundColor = `rgb(${r}, ${g}, ${b})`;
          }
        }
        // toggle表示
        if (controllerContainerElement.style.display === 'none') {
          controllerContainerElement.style.display = 'flex';
        } else {
          controllerContainerElement.style.display = 'none';
        }
        controllerContainerElement.style.top = '38px';
        controllerContainerElement.style.left = '-7px';
        controllerContainerElement.style.backgroundColor = backgroundColor;
        const buttonElements = controllerContainerElement.querySelectorAll('.ck-reaction-controller-button');
        buttonElements.forEach((buttonElement) => {
          buttonElement.style.backgroundColor = backgroundColor;
        });
      });
      iconContainerElement.appendChild(reactionIconElement);
      containerElement.appendChild(iconContainerElement);
      // インフォメーションブロック
      const infoContainerElement = document.createElement('div');
      infoContainerElement.className = 'ck-reaction-info-container';
      infoContainerElement.setAttribute('data-comment-id', commentId);
      containerElement.appendChild(infoContainerElement);
      // コントローラーブロック
      const controllerContainerElement = document.createElement('div');
      controllerContainerElement.className = 'ck-reaction-controller-container';
      controllerContainerElement.setAttribute('data-comment-id', commentId);
      controllerContainerElement.style.display = 'none';
      reactionTypes.forEach((reactionType) => {
        const reactionButton = document.createElement('button');
        reactionButton.className = 'ck-reaction-controller-button';
        reactionButton.innerHTML = reactionType.icon;
        reactionButton.setAttribute('data-comment-id', commentId);
        reactionButton.setAttribute('data-reaction-type', reactionType.type);
        // クリックだとフォーカスが移動するので mousedown を使用
        reactionButton.addEventListener('mousedown', (e) => {
          e.preventDefault();
          const editor = window.editor;
          const user = editor.config._config.customValues.user;
          const isReacted = e.target.getAttribute('data-is-reacted') === 'true';
          if (!window.reactionItems) {
            window.reactionItems = [];
          }
          if (isReacted === true) {
            if (confirm(editor.i18n.t('リアクションを取り消しますか？'))) {
              // リアクションの取り消し
              const userId = getLoginUserId();
              window.reactionItems = window.reactionItems.filter((item) => {
                return item.commentId !== commentId || item.type !== reactionType.type || item.user.user_id !== userId;
              });
              controllerContainerElement.style.display = 'none';
            }
          } else {
            // 新しいリアクションを追加
            const newReactionItem = {
              uuid: uuidv4(),
              commentId: commentId,
              type: reactionType.type,
              user: user,
              createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            };
            window.reactionItems = [...window.reactionItems, newReactionItem];
          }
          updateReactionInfo(commentId);
        });
        controllerContainerElement.appendChild(reactionButton);
      });
      containerElement.appendChild(controllerContainerElement);
      targetElement.appendChild(containerElement);
    }
    commentElement.setAttribute('data-has-reaction', 'true');
  });
};
const getIsComplete = (commentId) => {
  const threadElement = document
    .querySelector('.ck-comment[data-comment-id="' + commentId + '"]')
    .closest('.ck-thread');
  let isComplete = false;
  if (threadElement) {
    isComplete = threadElement.getAttribute('iscomplete') === 'true';
  }
  return isComplete;
};
const updateReactionInfo = (commentId) => {
  const infoContainerElement = document.querySelector(
    '.ck-reaction-info-container[data-comment-id="' + commentId + '"]'
  );
  if (infoContainerElement) {
    infoContainerElement.innerHTML = ''; // 既存内容をクリア
    const reactionItems = window.reactionItems.filter((item) => item.commentId === commentId);
    const groupedReactionItems = _.groupBy(reactionItems, 'type');
    for (const reactionType of reactionTypes) {
      const items = groupedReactionItems[reactionType.type] || [];
      if (items.length > 0) {
        const sortedItems = _.orderBy(items, 'createdAt', 'desc');
        const latestItem = sortedItems[0];
        const hssIds = [2];
        let isComplete = getIsComplete(commentId);
        let styles = { backgroundColor: '' };
        if (isComplete) {
          // コメントが完了している場合
          styles = { backgroundColor: '#DBDBDB' };
        } else if (hssIds.includes(latestItem.user.company_id)) {
          // 最新リアクション：HSSユーザー
          styles = { backgroundColor: '#f0f055' };
        } else {
          // 最新リアクション：原作ユーザー（2以外は原作）
          styles = { backgroundColor: '#D7E476' };
        }
        const reactionInfoElement = document.createElement('div');
        reactionInfoElement.className = 'ck-reaction-info-item';
        reactionInfoElement.innerHTML = `${reactionType.icon} ${items.length}`;
        for (const [key, value] of Object.entries(styles)) {
          reactionInfoElement.style[key] = value;
        }
        reactionInfoElement.addEventListener('mouseenter', () => {
          const tooltipElement = document.createElement('div');
          tooltipElement.setAttribute('data-comment-id', commentId);
          tooltipElement.className = 'ck-reaction-tooltip';
          const sortedItems = _.orderBy(items, 'createdAt', 'desc');
          const cellContent = sortedItems
            .map((item) => {
              const userName = item.user.user_name_ja || '(Unknown)';
              const createdAt = moment(item.createdAt).format('YYYY/MM/DD　HH:mm');
              return `<tr><td>${userName}:</td><td>${createdAt}</td></tr>`;
            })
            .join('');
          tooltipElement.innerHTML = `<table><tbody>${cellContent}</tbody></table>`;
          infoContainerElement.appendChild(tooltipElement);
        });
        reactionInfoElement.addEventListener('mouseleave', () => {
          // マウスアウトでTooltipを削除
          const tooltipElement = infoContainerElement.querySelector(
            '.ck-reaction-tooltip[data-comment-id="' + commentId + '"]'
          );
          if (tooltipElement) {
            infoContainerElement.removeChild(tooltipElement);
          }
        });
        infoContainerElement.appendChild(reactionInfoElement);
      }
    }
  }
};
const updateAllReactionInfo = () => {
  const commentsRepository = editor.plugins.get('CommentsRepository');
  const commentThreads = commentsRepository.getCommentThreads();
  Array.from(commentThreads).forEach((thread) => {
    const comments = thread.comments || [];
    Array.from(comments).forEach((comment) => {
      const commentId = comment.id;
      updateReactionInfo(commentId);
    });
  });
};
const hideAllReactionControllers = () => {
  const reactionControllerElements = document.querySelectorAll('.ck-reaction-controller-container');
  reactionControllerElements.forEach((element) => {
    element.style.display = 'none';
  });
};

const initContextMenu = (editor, callback) => {
  const editorElement = editor.ui.view.editable.element;
  if (editorElement) {
    editorElement.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    editorElement.addEventListener('mousedown', (e) => {
      // 右クリック
      if (e.button === 2) {
        e.preventDefault();
        const selection = document.getSelection();
        const element = e.target;
        if (typeof callback === 'function') {
          const mousePosition = {
            x: e.clientX,
            y: e.clientY,
          };
          callback({
            selection,
            element,
            mousePosition,
          });
        }
      }
    });
  }
};
// 移動式ダイアログ（React RND)のマウスドラッグでCKEditorにフォーカスされないようにする対策
const initPreventCkeditorFocus = () => {
  // イベント伝播の可/不可を切り替えるオーバーレイを作成
  const overLayStyles = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    zIndex: '9998', // React RND より背面であること
    display: 'block',
    backgroundColor: 'transparent',
    pointerEvents: 'none',
  };
  const overlay = document.createElement('div');
  Object.assign(overlay.style, overLayStyles);
  document.body.appendChild(overlay);

  window.addEventListener(
    'mousedown',
    (e) => {
      const isReactRndElement = !!e.target.closest('.react-draggable'); // React RNDはReact-draggableを使用しているため
      if (isReactRndElement) {
        overlay.style.pointerEvents = 'auto';
      }
      // 念のため、メモリリーク防止してます
      const stopDrag = () => {
        overlay.style.pointerEvents = 'none';
        window.removeEventListener('mouseup', stopDrag);
      };
      window.addEventListener('mouseup', stopDrag);
    },
    true // 親要素から順にイベントキャプチャ
  );
};

// Utils
const getEditor = () => {
  const editable = document.querySelector('.ck-editor__editable');
  if (editable) {
    return editable.ckeditorInstance;
  }
  return null;
};
const getLoginUserId = () => {
  const user = window.editor.config._config.customValues.user;
  return user ? Number(user.user_id) : -1;
};

export {
  addAttachmentLink,
  addAttachmentLinks,
  addReactionButtons,
  CommentAttachment,
  duplicateCommentThread,
  initCkeditorCommentEvents,
  initCkeditorList,
  initContextMenu,
  initPreventCkeditorFocus,
  setCkfinderRefresh,
  setMutationObserver,
  setStickyPanel,
  updateAllReactionInfo,
};
